exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.watermark_sprite-image_3vILs {\r\n    margin: auto;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n    max-width: 48px;\r\n    max-height: 48px;\r\n    opacity: 0.35;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"sprite-image": "watermark_sprite-image_3vILs",
	"spriteImage": "watermark_sprite-image_3vILs"
};